import { render, staticRenderFns } from "./ExcecoesSistema.vue?vue&type=template&id=6e3df1fe&scoped=true&"
import script from "./ExcecoesSistema.vue?vue&type=script&lang=js&"
export * from "./ExcecoesSistema.vue?vue&type=script&lang=js&"
import style0 from "./ExcecoesSistema.vue?vue&type=style&index=0&id=6e3df1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3df1fe",
  null
  
)

export default component.exports